/**
 * Merci : le changement de couleur dans la fenêtre d'ajout rapide.
 *
 * Chez Merci, une couleur n'est pas une variante : c'est un **autre produit**
 * (voir `blocks/merci-product-colors.liquid`). Sur la fiche, ses pastilles
 * sont donc des liens vers d'autres fiches. Dans la fenêtre d'ajout rapide, on
 * ne quitte pas la page — choix de Guillaume, le 2026-10-08 : un clic sur une
 * couleur recharge la fenêtre avec ce produit, par le même gabarit
 * `product.quick-add` qu'Horizon charge à l'ouverture (`assets/quick-add.js`).
 *
 * Vaut pour la rangée de pastilles comme pour le panneau « toutes nos
 * couleurs », qui se referme au passage. Si le chargement échoue, le lien
 * reprend son rôle : on ouvre la fiche de la couleur.
 *
 * Le suivi de l'upsell (`assets/merci-upsell-tracking.js`) suit le
 * changement : un ajout depuis une fenêtre ouverte par l'upsell compte, quelle
 * que soit la couleur finalement choisie.
 */

import { morph } from '@theme/morph';

/** @type {AbortController | null} */
let pending = null;

/** @param {string} url */
function quickAddUrl(url) {
  const target = new URL(url, window.location.origin);
  target.searchParams.set('view', 'quick-add');
  return target.toString();
}

document.addEventListener('click', async (event) => {
  const swatch = event.target instanceof Element ? event.target.closest('.merci-pdp-swatch') : null;
  if (!(swatch instanceof HTMLAnchorElement)) return;

  const content = swatch.closest('#quick-add-modal-content');
  if (!content) return;

  event.preventDefault();

  // Le panneau « toutes nos couleurs », s'il est ouvert, se referme.
  const drawer = swatch.closest('theme-drawer');
  if (drawer && 'close' in drawer && typeof drawer.close === 'function') drawer.close();

  if (swatch.classList.contains('is-active')) return;

  pending?.abort();
  pending = new AbortController();
  content.setAttribute('aria-busy', 'true');

  try {
    const response = await fetch(quickAddUrl(swatch.href), { signal: pending.signal });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const grid = html.querySelector('[data-product-grid-content]');
    if (!grid) throw new Error('Contenu d’ajout rapide introuvable');

    content.setAttribute('view-event-payload', grid.getAttribute('view-event-payload') || '');
    morph(content, grid);
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') return;
    window.location.href = swatch.href;
  } finally {
    content.removeAttribute('aria-busy');
  }
});
